import firebase from 'firebase/app'
import { HTTP } from '@/http-common'

export default {
  state: {
    loadedAlarms: [],
    alarmsLoading: false
  },
  getters: {
    loadedAlarms (state) {
      return state.loadedAlarms
    },
    alarmsLoading (state) {
      return state.alarmsLoading
    }
  },
  // synchronous
  mutations: {
    setLoadedAlarms (state, payload) {
      state.loadedAlarms = payload
    },
    setAlarmsLoading (state, payload) {
      state.alarmsLoading = payload
    },
    clearLoadedAlarms (state) {
      state.loadedAlarms = []
    }
  },
  // asynchronous
  actions: {
    loadAlarms ({ commit }, payload) {
      console.log('load alarms here')
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedAlarms', [])

      firebase.auth().currentUser.getIdToken()
        .then(token => {
          HTTP.get('smaai5/alarm?mac=' + payload.mac + '&offset=' + payload.offset + '&limit=25&order=DESC',
            { headers: { 'Authorization': 'Bearer ' + token } })
            .then(res => {
              console.log(res)
              if (Array.isArray(res.data)) {
                let id = 0
                const _data = res.data.map(function (data) {
                  data.id = id
                  id = id + 1
                  return data
                })
                commit('setLoadedAlarms', _data)
              }
              commit('setLoading', false)
            })
            .catch(err => {
              console.log(err)
              commit('setLoading', false)
              commit('setError', err)
            })
        })
        .catch(err => {
          console.log(err)
          commit('setLoading', false)
          commit('setError', err)
        })
    },
    loadAlarmsWithAlarmsLoading ({ commit }, payload) {
      console.log('load alarms here')
      commit('clearError')
      commit('setAlarmsLoading', true)
      commit('setLoadedAlarms', [])

      firebase.auth().currentUser.getIdToken()
        .then(token => {
          HTTP.get('smaai5/alarm?mac=' + payload.mac + '&offset=' + payload.offset + '&limit=25&order=DESC',
            { headers: { 'Authorization': 'Bearer ' + token } })
            .then(res => {
              console.log(res)
              if (Array.isArray(res.data)) {
                console.log('is array')
                let id = 1
                const _data = res.data.map(function (data) {
                  data.id = id
                  id = id + 1
                  return data
                })
                commit('setLoadedAlarms', _data)
              }
            })
            .catch(err => {
              console.log(err)
              commit('setError', err)
            })
        })
        .catch(err => {
          console.log(err)
          commit('setAlarmsLoading', false)
          commit('setError', err)
        })
        .finally(() => {
          commit('setAlarmsLoading', false)
        })
    },
    clearLoadedAlarms ({ commit }) {
      commit('clearLoadedAlarms')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/alarm/index.js